/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "0.1.0 nightly 2025-05-24",
    versionChannel: "nightly",
    buildDate: "2025-05-24T00:06:51.350Z",
    commitHash: "7926c72cbd512629cf965159a7e89c3b2a29c7c0",
};
